<permission-checker [roles]="roles" (contentInit)="initContent()">
  <div class="content-holder">
    <contest-select-panel [competitionId]="competitionId"
                          [contest]="contest"
                          [mobileView]="mobileView"
                          [showDetails]="false"
                          (selected)="contestSelected($event)"></contest-select-panel>

    <mat-accordion *ngIf="user" class="filters-panel">
      <mat-expansion-panel [expanded]="!region || !school">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <ng-container *ngIf="region">{{region.name}}</ng-container>
            <ng-container *ngIf="!region"
                          i18n="User Profile|School region select input label@@user-profile-school-region-select-input-label"
            >Select Region</ng-container>
          </mat-panel-title>
          <mat-panel-description>
            <ng-container *ngIf="school">{{school.short_name || school.name}}</ng-container>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <school-select
          [roles]="roles"
          [showGrade]="false"
          [showGradeType]="false"
          [allowGradeSelect]="false"
          [selectedRegion]="region"
          [allowRegionSelect]="true"
          [addAllRegionsOption]="false"
          [allowSchoolSelect]="true"
          [showSchool]="true"
          [selectedSchoolType]="schoolType"
          [selectedSchool]="school"
          [clearSchoolAfterSelect]="false"
          [allowSchoolClear]="true"
          [schoolRequired]="false"
          (regionSelected)="regionSelected($event)"
          (schoolSelected)="schoolSelected($event.school, $event.region)"></school-select>
      </mat-expansion-panel>
    </mat-accordion>

    <app-no-content *ngIf="!inProgress && !contest"
                    [compact]="true"
                    title="Please select a contest and region from the list first"
                    i18n-title="Stats Dashboard|Select contest and region prompt@@stats-dashboard-select-contest-and-region-prompt">
    </app-no-content>

    <mat-list *ngIf="!inProgress" class="reports-list">
      <mat-list-item [disabled]="!contest || !region || !!school" [class.text-disabled-color]="!contest || !region"
                     class="report">
        <span i18n="Navigation|Contest region results title@@navigation-contest-region-results-stats-title">Contest Region Results</span>
        <span class="fill-space"></span>
        <a class="print-link"
           [routerLink]="getPrintUrl"
           target="_blank"
           (click)="$event.stopPropagation();">
          <mat-icon [color]="contest && region && !school ? 'primary' : undefined"
                    [class.text-disabled-color]="!contest || !region || !!school"
                    class="print-icon">print
          </mat-icon>
        </a>
      </mat-list-item>

      <mat-list-item [disabled]="!contest || !region || !school" [class.text-disabled-color]="!contest || !region"
                     class="report">
        <span i18n="Navigation|Contest school results title@@navigation-contest-school-results-stats-title">Contest School Results</span>
        <span class="fill-space"></span>
        <a class="print-link"
           [routerLink]="getPrintUrl"
           [queryParams]="getPrintUrlQueryParams"
           target="_blank"
           (click)="$event.stopPropagation();">
          <mat-icon [color]="contest && region && school ? 'primary' : undefined"
                    [class.text-disabled-color]="!contest || !region || !school"
                    class="print-icon">print
          </mat-icon>
        </a>
      </mat-list-item>

      <mat-list-item [disabled]="!contest || !region" [class.text-disabled-color]="!contest || !region" class="report">
        <span
          i18n="Navigation|Contest region schools result title@@navigation-contest-region-schools-result-stats-title">Contest Region Schools Result</span>
        <span class="fill-space"></span>
        <a class="print-link"
           [routerLink]="getRegionSchoolsResultPrintUrl"
           target="_blank"
           (click)="$event.stopPropagation();">
          <mat-icon [color]="contest && region && !school ? 'primary' : undefined"
                    [class.text-disabled-color]="!contest || !region || !!school"
                    class="print-icon">print
          </mat-icon>
        </a>
      </mat-list-item>
    </mat-list>

    <mat-spinner *ngIf="inProgress" color="primary" diameter="30" class="center progress"></mat-spinner>
  </div>
</permission-checker>
